const showExpertContact = (() => {
  // Obliczanie daty Wielkanocy (zgodnie z algorytmem Meeusa/Jonesa/Butchera)
  function getEasterDate(year) {
    const f = Math.floor,
      G = year % 19,
      C = f(year / 100),
      H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
      I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
      J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
      L = I - J,
      month = 3 + f((L + 40) / 44),
      day = L + 28 - 31 * f(month / 4);
    return new Date(year, month - 1, day);
  }

  // Funkcja pomocnicza do formatowania daty w formacie YYYY-MM-DD
  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Obliczanie daty Bożego Ciała (60 dni po Wielkanocy)
  function getCorpusChristiDate(year) {
    const easter = getEasterDate(year);
    const corpusChristi = new Date(easter);
    corpusChristi.setDate(corpusChristi.getDate() + 60);
    return formatDate(corpusChristi);
  }

  // Funkcja sprawdzająca, czy dana data jest dniem wolnym
  function isHoliday(date) {
    const year = date.getFullYear();
    const holidays = [
      // Nowy Rok (1 stycznia)
      `${year}-01-01`,
      // Święto Trzech Króli (6 stycznia)
      `${year}-01-06`,
      // Święto Pracy (1 maja)
      `${year}-05-01`,
      // Święto Konstytucji 3 Maja (3 maja)
      `${year}-05-03`,
      // Boże Ciało (zmienny, obliczany z reguł)
      getCorpusChristiDate(year),
      // Wniebowzięcie NMP (15 sierpnia)
      `${year}-08-15`,
      // Wszystkich Świętych (1 listopada)
      `${year}-11-01`,
      // Narodowe Święto Niepodległości (11 listopada)
      `${year}-11-11`,
      // Boże Narodzenie (25 i 26 grudnia)
      `${year}-12-25`,
      `${year}-12-26`,
    ];

    // Obliczamy Wielkanoc (zmienny, obliczany z reguł)
    const easter = getEasterDate(year);
    const easterMonday = new Date(easter);
    easterMonday.setDate(easterMonday.getDate() + 1);

    holidays.push(formatDate(easter)); // Wielkanoc
    holidays.push(formatDate(easterMonday)); // Poniedziałek Wielkanocny

    const currentDate = formatDate(date);
    return holidays.includes(currentDate);
  }

  return {
    // Główna logika
    checkDate: () => {
      const now = new Date();
      const dayOfWeek = now.getDay();
      const hour = now.getHours();

      // Sprawdzamy, czy dzień poniedziałek, wtorek, środa, czwartek lub piątek
      const isMondayOrTuesday = (dayOfWeek === 1 || dayOfWeek === 2 || dayOfWeek === 3 || dayOfWeek === 4 || dayOfWeek === 5);
      // Sprawdzamy, czy godzina jest między 8:00 a 15:00
      const isWorkingHours = (hour >= 8 && hour < 16);
      // Sprawdzamy, czy nie jest dniem wolnym
      const isNotHoliday = !isHoliday(now);

      // Sprawdzamy wszystkie warunki
      return isMondayOrTuesday && isWorkingHours && isNotHoliday;
    },
  };
})();

export default showExpertContact;
